import MessageBusTopics from '../../common/MessageBusTopics';
import docCookies from 'doc-cookies';
import '../../vendor/lightningjs/lightningjs-embed';

/**
 * Usabilla feedback.
 *
 * @module app/components/FeedbackComponent
 */

/**
 * This function is to subscribe usabilla to messageBus.
 *
 * @returns {void}
 *
 * @private
 */
const usabillaFeedback = () => {
    window.WH.messageBus.subscribe(MessageBusTopics.FEEDBACK_USABILLA, () => handleUsabilla());
};

const config = window.WH.sportsbook.frontEndConfig.usabilla;

const shouldInitUsabilla = () =>
    config && config.enabled && config.url;

const openUsabilla = () => window.usabilla_live('click');

const handleUsabilla = () => {
    if (window.usabilla_live) {
        openUsabilla();
    } else {
        if (shouldInitUsabilla()) {
            initUsabilla();
            openUsabilla();
        }
    }
};

/* eslint-disable no-undef */
const isobUvsRatingAvailable = () =>
    typeof uvsObject === 'object'&&
    typeof uvsObject.UVS === 'string' &&
    uvsObject.UVS !== '';

const isWHXobUvsRatingAvailable = () =>
    typeof WHX === 'object' &&
    typeof WHX.data === 'object' &&
    typeof WHX.data.obUvsRating === 'string' &&
    WHX.data.obUvsRating !== '';
/* eslint-enable no-undef */

const initUsabilla = () => {
    window.usabilla_live = window.lightningjs.require('usabilla_live', config.url);
    const accId = docCookies.getItem('trk_uid') || '';
    let uvs = '';
    /* eslint-disable no-undef */
    if (isobUvsRatingAvailable()) {
        uvs = uvsObject.UVS;
    } else if (isWHXobUvsRatingAvailable()) {
        uvs = WHX.data.obUvsRating;
    }
    /* eslint-enable no-undef */
    window.usabilla_live('data', {
        custom: {
            'Acc_No': accId,
            'UVS': uvs,
        },
    });
};

/**
 * Public functions.
 *
 * @type {Object}
 */
const api = {

    /**
     * Initialise feedback component.
     *
     * @returns {void}
     *
     * @public
     */
    init: function init () {
        usabillaFeedback();
    },
};

export default api;